<script>
/* eslint-disable semi */
import { Component, Inject } from 'vue-property-decorator';
import AppSelect from './AppSelect';

const debug = process.env.NODE_ENV === 'development';

@Component
export default class AppDynamicSelect extends AppSelect {
  // 上位のフォームコンポーネントで公開されたフォームデータを参照
  @Inject('_app_form') form;

  // 初期化
  initialize () {
    // 動的パラメータ監視
    const dynamicParams = this.options.dynamicParams;
    Object.keys(dynamicParams).forEach(prop => {
      this.$watch(`form.model.${prop}`, function (newVal, oldVal) {
        this.fetchOptions();
      });
    })
    this.fetchOptions();
  }

  /**
   * 選択オプションを取得する
   * 選択オプションは、options.url で指定されたAPIから取得する。
   */
  fetchOptionsImpl () {
    // 静的選択肢はサポートしない
    if (this.options.static !== undefined && this.options.static !== null) {
      throw new Error('Static options is not supported by AppDynamicSelect.');
    }

    const url = this.options.api;

    // 動的パラメータ取得
    // ログイン中の会社コード・拠点事業所コードについては下記のプロパティ名を指定して参照する
    // loginUserKaishaCode
    // loginUserKyotenJigyohshoCode
    const params = {};
    const dynamicParams = this.options.dynamicParams;
    const filled = Object.keys(dynamicParams).every(prop => {
      if (prop in this.form.model) {
        const value = this.form.model[prop];
        params[dynamicParams[prop]] = this.form.model[prop];
        return (value !== null && value !== undefined && value !== '');
      } else if (prop === 'loginUserKaishaCode') {
        if (debug) {
          console.debug('[kaisha_code] login user', this);
        }
        params[dynamicParams[prop]] = this.$store.getters.user.kaishaCode;
        return true;
      } else if (prop === 'loginUserKyotenJigyohshoCode') {
        if (debug) {
          console.debug('[kyoten_jigyohsho_code] login user', this);
        }
        params[dynamicParams[prop]] = this.$store.getters.user.kyotenJigyohshoCode;
        return true;
      } else {
        return false;
      }
    })

    // データ読込
    if (!filled) {
      // 既存データクリア
      this.model = ('default' in this.options) ? this.options.default : null;
      return Promise.resolve(() => []);
    } else {
      return this.$_sas.$cache.segment(url).get(params, () => {
        return this.$_sas.$api.cancel().get(url, {params})
          .then(response => {
            let options = [];

            // データ変換
            if ('filter' in this.options) {
              options = this.options.filter(response.data.results);
            }

            // 既存データクリア判定
            const exists = (Array.isArray(options)) && (options.some(item => item.value === this.model));
            if (!exists) {
              this.model = ('default' in this.options) ? this.options.default : null;
            }

            // 選択値追加
            if ('before-options' in this.options) {
              options.unshift(...this.options['before-options']);
            }
            if ('after-options' in this.options) {
              options.push(...this.options['after-options']);
            }

            // データ返却
            return options;
          });
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/parts/select/AppDynamicSelect.vue